import { createSlice } from '@reduxjs/toolkit';

import {
  AddSpinnerPayload,
  AddSystemNoticePayload,
  PrependNotificationsPayload,
  RemoveSpinnerPayload,
  RemoveSystemNoticePayload,
  SetNewNotificationsPayload,
  SetNotificationsPayload,
  SetUserPayload,
  SystemState,
  UpdateSystemUserDeviceIdPayload
} from './system.types';

import { generateUUID } from '../../utils/util';

export const initialState: SystemState = {
  notices: [],
  spinners: [],
  user: undefined,
  notifications: [],
  newNotifications: false
};

export const SystemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    addSystemNotice: (state, action: AddSystemNoticePayload) => {
      const { type, message } = action.payload;

      state.notices.push({ id: generateUUID(), type, message });
    },
    removeSystemNotice: (state, action: RemoveSystemNoticePayload) => {
      const updatedNotices = state.notices.filter((notice) => notice.id !== action.payload);
      state.notices = updatedNotices;
    },
    addSpinner: (state, action: AddSpinnerPayload) => {
      state.spinners.push(action.payload);
    },
    removeSpinner: (state, action: RemoveSpinnerPayload) => {
      state.spinners = state.spinners.filter((spinner) => spinner !== action.payload);
    },
    setUser: (state, action: SetUserPayload) => {
      state.user = action.payload;
    },
    setNotifications: (state, action: SetNotificationsPayload) => {
      state.notifications = action.payload;
    },
    prependNotifications: (state, action: PrependNotificationsPayload) => {
      state.notifications = [...action.payload, ...state.notifications];
    },
    setNewNotifications: (state, action: SetNewNotificationsPayload) => {
      state.newNotifications = action.payload;
    },
    updateSystemUserDeviceId: (state, action: UpdateSystemUserDeviceIdPayload) => {
      if (state.user) {
        state.user.deviceId = action.payload;
      }
    }
  }
});

export const {
  addSystemNotice,
  removeSystemNotice,
  addSpinner,
  removeSpinner,
  setUser,
  setNotifications,
  prependNotifications,
  setNewNotifications,
  updateSystemUserDeviceId
} = SystemSlice.actions;

export default SystemSlice.reducer;
